export const endsWithAnyOf = (subject: string, possibleMatches: string[]) =>
    (subject === ''
        ? possibleMatches
        : possibleMatches.filter(possibleMatch => possibleMatch !== '')
    ).some(possibleMatch => subject.endsWith(possibleMatch));
